'use strict';

function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function _classCallCheck(a, n) { if (!(a instanceof n)) throw new TypeError("Cannot call a class as a function"); }
function _defineProperties(e, r) { for (var t = 0; t < r.length; t++) { var o = r[t]; o.enumerable = o.enumerable || !1, o.configurable = !0, "value" in o && (o.writable = !0), Object.defineProperty(e, _toPropertyKey(o.key), o); } }
function _createClass(e, r, t) { return r && _defineProperties(e.prototype, r), t && _defineProperties(e, t), Object.defineProperty(e, "prototype", { writable: !1 }), e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
function _callSuper(t, o, e) { return o = _getPrototypeOf(o), _possibleConstructorReturn(t, _isNativeReflectConstruct() ? Reflect.construct(o, e || [], _getPrototypeOf(t).constructor) : o.apply(t, e)); }
function _possibleConstructorReturn(t, e) { if (e && ("object" == _typeof(e) || "function" == typeof e)) return e; if (void 0 !== e) throw new TypeError("Derived constructors may only return object or undefined"); return _assertThisInitialized(t); }
function _assertThisInitialized(e) { if (void 0 === e) throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); return e; }
function _isNativeReflectConstruct() { try { var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); } catch (t) {} return (_isNativeReflectConstruct = function _isNativeReflectConstruct() { return !!t; })(); }
function _getPrototypeOf(t) { return _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function (t) { return t.__proto__ || Object.getPrototypeOf(t); }, _getPrototypeOf(t); }
function _inherits(t, e) { if ("function" != typeof e && null !== e) throw new TypeError("Super expression must either be null or a function"); t.prototype = Object.create(e && e.prototype, { constructor: { value: t, writable: !0, configurable: !0 } }), Object.defineProperty(t, "prototype", { writable: !1 }), e && _setPrototypeOf(t, e); }
function _setPrototypeOf(t, e) { return _setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function (t, e) { return t.__proto__ = e, t; }, _setPrototypeOf(t, e); }
var BaseApi = require('./utils/baseApi');
var RequestProvider = require('ky')["default"];

/**
* @typedef {import('ky').Options} RequestProviderOptions
*/

/**
* @typedef {import('ky').Options.searchParams} SDKRequestSearchParams
*/

/**
* @typedef {import('ky').Options.context} SDKRequestContext
*/

/**
* @typedef {import('ky').Options} SDKRequestOptions
*/

var Acl = require('./services/acl');
var Appointment = require('./services/appointment');
var Apporteur = require('./services/apporteur');
var Audit = require('./services/audit');
var Authentication = require('./services/authentication');
var Blacklist = require('./services/blacklist');
var Bookmark = require('./services/bookmark');
var Calendar = require('./services/calendar');
var ClientSpace = require('./services/client-space');
var Client = require('./services/client');
var Commercialisation = require('./services/commercialisation');
var Commission = require('./services/commission');
var Company = require('./services/company');
var Document = require('./services/document');
var Docusign = require('./services/docusign');
var Feed = require('./services/feed');
var Geo = require('./services/geo');
var Image = require('./services/image');
var Lead = require('./services/lead');
var Mail = require('./services/mail');
var Mailchimp = require('./services/mailchimp');
var Mandate = require('./services/mandate');
var Marketplace = require('./services/marketplace');
var Netexplorer = require('./services/netexplorer');
var Notification = require('./services/notification');
var Partner = require('./services/partner');
var Pdf = require('./services/pdf');
var Phone = require('./services/phone');
var PrestigePropertyGroup = require('./services/prestige-property-group');
var Property = require('./services/property');
var PublisherApits = require('./services/publisher-apits');
var PublisherBellesPierres = require('./services/publisher-belles-pierres');
var PublisherDatabase = require('./services/publisher-database');
var PublisherElasticsearch = require('./services/publisher-elasticsearch');
var PublisherFrancePropertyShop = require('./services/publisher-france-property-shop');
var PublisherFrenchProperty = require('./services/publisher-french-property');
var PublisherGreenAcres = require('./services/publisher-green-acres');
var PublisherHamptons = require('./services/publisher-hamptons');
var PublisherLuxResidence = require('./services/publisher-lux-residence');
var PublisherOldElasticsearch = require('./services/publisher-old-elasticsearch');
var PublisherParuvendu = require('./services/publisher-paruvendu');
var PublisherPrestige = require('./services/publisher-prestige');
var PublisherQualis = require('./services/publisher-qualis');
var PublisherRightmove = require('./services/publisher-rightmove');
var PublisherScout24 = require('./services/publisher-scout24');
var PublisherSeloger = require('./services/publisher-seloger');
var PublisherSki = require('./services/publisher-ski');
var PublisherUbiflow = require('./services/publisher-ubiflow');
var PublisherZoopla = require('./services/publisher-zoopla');
var Rhinov = require('./services/rhinov');
var Taktik = require('./services/taktik');
var Template = require('./services/template');
var Tenant = require('./services/tenant');
var Thread = require('./services/thread');
var Timemachine = require('./services/timemachine');
var User = require('./services/user');
var Wallet = require('./services/wallet');

/**
* @class HestiaApi
* 
* @property { AclServiceApi } Acl
* @property { AppointmentServiceApi } Appointment
* @property { ApporteurServiceApi } Apporteur
* @property { AuditServiceApi } Audit
* @property { AuthenticationServiceApi } Authentication
* @property { BlacklistServiceApi } Blacklist
* @property { BookmarkServiceApi } Bookmark
* @property { CalendarServiceApi } Calendar
* @property { ClientSpaceServiceApi } ClientSpace
* @property { ClientServiceApi } Client
* @property { CommercialisationServiceApi } Commercialisation
* @property { CommissionServiceApi } Commission
* @property { CompanyServiceApi } Company
* @property { DocumentServiceApi } Document
* @property { DocusignServiceApi } Docusign
* @property { FeedServiceApi } Feed
* @property { GeoServiceApi } Geo
* @property { ImageServiceApi } Image
* @property { LeadServiceApi } Lead
* @property { MailServiceApi } Mail
* @property { MailchimpServiceApi } Mailchimp
* @property { MandateServiceApi } Mandate
* @property { MarketplaceServiceApi } Marketplace
* @property { NetexplorerServiceApi } Netexplorer
* @property { NotificationServiceApi } Notification
* @property { PartnerServiceApi } Partner
* @property { PdfServiceApi } Pdf
* @property { PhoneServiceApi } Phone
* @property { PrestigePropertyGroupServiceApi } PrestigePropertyGroup
* @property { PropertyServiceApi } Property
* @property { PublisherApitsServiceApi } PublisherApits
* @property { PublisherBellesPierresServiceApi } PublisherBellesPierres
* @property { PublisherDatabaseServiceApi } PublisherDatabase
* @property { PublisherElasticsearchServiceApi } PublisherElasticsearch
* @property { PublisherFrancePropertyShopServiceApi } PublisherFrancePropertyShop
* @property { PublisherFrenchPropertyServiceApi } PublisherFrenchProperty
* @property { PublisherGreenAcresServiceApi } PublisherGreenAcres
* @property { PublisherHamptonsServiceApi } PublisherHamptons
* @property { PublisherLuxResidenceServiceApi } PublisherLuxResidence
* @property { PublisherOldElasticsearchServiceApi } PublisherOldElasticsearch
* @property { PublisherParuvenduServiceApi } PublisherParuvendu
* @property { PublisherPrestigeServiceApi } PublisherPrestige
* @property { PublisherQualisServiceApi } PublisherQualis
* @property { PublisherRightmoveServiceApi } PublisherRightmove
* @property { PublisherScout24ServiceApi } PublisherScout24
* @property { PublisherSelogerServiceApi } PublisherSeloger
* @property { PublisherSkiServiceApi } PublisherSki
* @property { PublisherUbiflowServiceApi } PublisherUbiflow
* @property { PublisherZooplaServiceApi } PublisherZoopla
* @property { RhinovServiceApi } Rhinov
* @property { TaktikServiceApi } Taktik
* @property { TemplateServiceApi } Template
* @property { TenantServiceApi } Tenant
* @property { ThreadServiceApi } Thread
* @property { TimemachineServiceApi } Timemachine
* @property { UserServiceApi } User
* @property { WalletServiceApi } Wallet
*/
var HestiaApi = /*#__PURE__*/function (_BaseApi) {
  /**
  * @param {RequestProviderOptions} options
  */
  function HestiaApi(options) {
    var _this;
    _classCallCheck(this, HestiaApi);
    _this = _callSuper(this, HestiaApi, [options, RequestProvider]);
    _this.Acl = new Acl(_this.http);
    _this.Appointment = new Appointment(_this.http);
    _this.Apporteur = new Apporteur(_this.http);
    _this.Audit = new Audit(_this.http);
    _this.Authentication = new Authentication(_this.http);
    _this.Blacklist = new Blacklist(_this.http);
    _this.Bookmark = new Bookmark(_this.http);
    _this.Calendar = new Calendar(_this.http);
    _this.ClientSpace = new ClientSpace(_this.http);
    _this.Client = new Client(_this.http);
    _this.Commercialisation = new Commercialisation(_this.http);
    _this.Commission = new Commission(_this.http);
    _this.Company = new Company(_this.http);
    _this.Document = new Document(_this.http);
    _this.Docusign = new Docusign(_this.http);
    _this.Feed = new Feed(_this.http);
    _this.Geo = new Geo(_this.http);
    _this.Image = new Image(_this.http);
    _this.Lead = new Lead(_this.http);
    _this.Mail = new Mail(_this.http);
    _this.Mailchimp = new Mailchimp(_this.http);
    _this.Mandate = new Mandate(_this.http);
    _this.Marketplace = new Marketplace(_this.http);
    _this.Netexplorer = new Netexplorer(_this.http);
    _this.Notification = new Notification(_this.http);
    _this.Partner = new Partner(_this.http);
    _this.Pdf = new Pdf(_this.http);
    _this.Phone = new Phone(_this.http);
    _this.PrestigePropertyGroup = new PrestigePropertyGroup(_this.http);
    _this.Property = new Property(_this.http);
    _this.PublisherApits = new PublisherApits(_this.http);
    _this.PublisherBellesPierres = new PublisherBellesPierres(_this.http);
    _this.PublisherDatabase = new PublisherDatabase(_this.http);
    _this.PublisherElasticsearch = new PublisherElasticsearch(_this.http);
    _this.PublisherFrancePropertyShop = new PublisherFrancePropertyShop(_this.http);
    _this.PublisherFrenchProperty = new PublisherFrenchProperty(_this.http);
    _this.PublisherGreenAcres = new PublisherGreenAcres(_this.http);
    _this.PublisherHamptons = new PublisherHamptons(_this.http);
    _this.PublisherLuxResidence = new PublisherLuxResidence(_this.http);
    _this.PublisherOldElasticsearch = new PublisherOldElasticsearch(_this.http);
    _this.PublisherParuvendu = new PublisherParuvendu(_this.http);
    _this.PublisherPrestige = new PublisherPrestige(_this.http);
    _this.PublisherQualis = new PublisherQualis(_this.http);
    _this.PublisherRightmove = new PublisherRightmove(_this.http);
    _this.PublisherScout24 = new PublisherScout24(_this.http);
    _this.PublisherSeloger = new PublisherSeloger(_this.http);
    _this.PublisherSki = new PublisherSki(_this.http);
    _this.PublisherUbiflow = new PublisherUbiflow(_this.http);
    _this.PublisherZoopla = new PublisherZoopla(_this.http);
    _this.Rhinov = new Rhinov(_this.http);
    _this.Taktik = new Taktik(_this.http);
    _this.Template = new Template(_this.http);
    _this.Tenant = new Tenant(_this.http);
    _this.Thread = new Thread(_this.http);
    _this.Timemachine = new Timemachine(_this.http);
    _this.User = new User(_this.http);
    _this.Wallet = new Wallet(_this.http);
    return _this;
  }
  _inherits(HestiaApi, _BaseApi);
  return _createClass(HestiaApi, [{
    key: "http",
    get: function get() {
      return this._http;
    },
    set: function set(http) {
      this._http = http;
      this.Acl.setHttp(http);
      this.Appointment.setHttp(http);
      this.Apporteur.setHttp(http);
      this.Audit.setHttp(http);
      this.Authentication.setHttp(http);
      this.Blacklist.setHttp(http);
      this.Bookmark.setHttp(http);
      this.Calendar.setHttp(http);
      this.ClientSpace.setHttp(http);
      this.Client.setHttp(http);
      this.Commercialisation.setHttp(http);
      this.Commission.setHttp(http);
      this.Company.setHttp(http);
      this.Document.setHttp(http);
      this.Docusign.setHttp(http);
      this.Feed.setHttp(http);
      this.Geo.setHttp(http);
      this.Image.setHttp(http);
      this.Lead.setHttp(http);
      this.Mail.setHttp(http);
      this.Mailchimp.setHttp(http);
      this.Mandate.setHttp(http);
      this.Marketplace.setHttp(http);
      this.Netexplorer.setHttp(http);
      this.Notification.setHttp(http);
      this.Partner.setHttp(http);
      this.Pdf.setHttp(http);
      this.Phone.setHttp(http);
      this.PrestigePropertyGroup.setHttp(http);
      this.Property.setHttp(http);
      this.PublisherApits.setHttp(http);
      this.PublisherBellesPierres.setHttp(http);
      this.PublisherDatabase.setHttp(http);
      this.PublisherElasticsearch.setHttp(http);
      this.PublisherFrancePropertyShop.setHttp(http);
      this.PublisherFrenchProperty.setHttp(http);
      this.PublisherGreenAcres.setHttp(http);
      this.PublisherHamptons.setHttp(http);
      this.PublisherLuxResidence.setHttp(http);
      this.PublisherOldElasticsearch.setHttp(http);
      this.PublisherParuvendu.setHttp(http);
      this.PublisherPrestige.setHttp(http);
      this.PublisherQualis.setHttp(http);
      this.PublisherRightmove.setHttp(http);
      this.PublisherScout24.setHttp(http);
      this.PublisherSeloger.setHttp(http);
      this.PublisherSki.setHttp(http);
      this.PublisherUbiflow.setHttp(http);
      this.PublisherZoopla.setHttp(http);
      this.Rhinov.setHttp(http);
      this.Taktik.setHttp(http);
      this.Template.setHttp(http);
      this.Tenant.setHttp(http);
      this.Thread.setHttp(http);
      this.Timemachine.setHttp(http);
      this.User.setHttp(http);
      this.Wallet.setHttp(http);
    }
  }], [{
    key: "services",
    get: function get() {
      return ['Acl', 'Appointment', 'Apporteur', 'Audit', 'Authentication', 'Blacklist', 'Bookmark', 'Calendar', 'ClientSpace', 'Client', 'Commercialisation', 'Commission', 'Company', 'Document', 'Docusign', 'Feed', 'Geo', 'Image', 'Lead', 'Mail', 'Mailchimp', 'Mandate', 'Marketplace', 'Netexplorer', 'Notification', 'Partner', 'Pdf', 'Phone', 'PrestigePropertyGroup', 'Property', 'PublisherApits', 'PublisherBellesPierres', 'PublisherDatabase', 'PublisherElasticsearch', 'PublisherFrancePropertyShop', 'PublisherFrenchProperty', 'PublisherGreenAcres', 'PublisherHamptons', 'PublisherLuxResidence', 'PublisherOldElasticsearch', 'PublisherParuvendu', 'PublisherPrestige', 'PublisherQualis', 'PublisherRightmove', 'PublisherScout24', 'PublisherSeloger', 'PublisherSki', 'PublisherUbiflow', 'PublisherZoopla', 'Rhinov', 'Taktik', 'Template', 'Tenant', 'Thread', 'Timemachine', 'User', 'Wallet'];
    }
  }]);
}(BaseApi);
/**
* @typedef {Object} HestiaApiServices
*
* @property {HestiaApi} HestiaApi
* 
* @property { AclServiceApi } AclApi 
* @property { AppointmentServiceApi } AppointmentApi 
* @property { ApporteurServiceApi } ApporteurApi 
* @property { AuditServiceApi } AuditApi 
* @property { AuthenticationServiceApi } AuthenticationApi 
* @property { BlacklistServiceApi } BlacklistApi 
* @property { BookmarkServiceApi } BookmarkApi 
* @property { CalendarServiceApi } CalendarApi 
* @property { ClientSpaceServiceApi } ClientSpaceApi 
* @property { ClientServiceApi } ClientApi 
* @property { CommercialisationServiceApi } CommercialisationApi 
* @property { CommissionServiceApi } CommissionApi 
* @property { CompanyServiceApi } CompanyApi 
* @property { DocumentServiceApi } DocumentApi 
* @property { DocusignServiceApi } DocusignApi 
* @property { FeedServiceApi } FeedApi 
* @property { GeoServiceApi } GeoApi 
* @property { ImageServiceApi } ImageApi 
* @property { LeadServiceApi } LeadApi 
* @property { MailServiceApi } MailApi 
* @property { MailchimpServiceApi } MailchimpApi 
* @property { MandateServiceApi } MandateApi 
* @property { MarketplaceServiceApi } MarketplaceApi 
* @property { NetexplorerServiceApi } NetexplorerApi 
* @property { NotificationServiceApi } NotificationApi 
* @property { PartnerServiceApi } PartnerApi 
* @property { PdfServiceApi } PdfApi 
* @property { PhoneServiceApi } PhoneApi 
* @property { PrestigePropertyGroupServiceApi } PrestigePropertyGroupApi 
* @property { PropertyServiceApi } PropertyApi 
* @property { PublisherApitsServiceApi } PublisherApitsApi 
* @property { PublisherBellesPierresServiceApi } PublisherBellesPierresApi 
* @property { PublisherDatabaseServiceApi } PublisherDatabaseApi 
* @property { PublisherElasticsearchServiceApi } PublisherElasticsearchApi 
* @property { PublisherFrancePropertyShopServiceApi } PublisherFrancePropertyShopApi 
* @property { PublisherFrenchPropertyServiceApi } PublisherFrenchPropertyApi 
* @property { PublisherGreenAcresServiceApi } PublisherGreenAcresApi 
* @property { PublisherHamptonsServiceApi } PublisherHamptonsApi 
* @property { PublisherLuxResidenceServiceApi } PublisherLuxResidenceApi 
* @property { PublisherOldElasticsearchServiceApi } PublisherOldElasticsearchApi 
* @property { PublisherParuvenduServiceApi } PublisherParuvenduApi 
* @property { PublisherPrestigeServiceApi } PublisherPrestigeApi 
* @property { PublisherQualisServiceApi } PublisherQualisApi 
* @property { PublisherRightmoveServiceApi } PublisherRightmoveApi 
* @property { PublisherScout24ServiceApi } PublisherScout24Api 
* @property { PublisherSelogerServiceApi } PublisherSelogerApi 
* @property { PublisherSkiServiceApi } PublisherSkiApi 
* @property { PublisherUbiflowServiceApi } PublisherUbiflowApi 
* @property { PublisherZooplaServiceApi } PublisherZooplaApi 
* @property { RhinovServiceApi } RhinovApi 
* @property { TaktikServiceApi } TaktikApi 
* @property { TemplateServiceApi } TemplateApi 
* @property { TenantServiceApi } TenantApi 
* @property { ThreadServiceApi } ThreadApi 
* @property { TimemachineServiceApi } TimemachineApi 
* @property { UserServiceApi } UserApi 
* @property { WalletServiceApi } WalletApi 
*/
module.exports = HestiaApi;